'use strict';

export default function bind(fn, thisArg) {
 return function wrap() {
 return fn.apply(thisArg, arguments);
 };
}
